var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7891 13.91C9.25708 13.91 6.3938 11.079 6.3938 7.58685C6.3938 4.09613 9.25708 1.26514 12.7891 1.26514C16.3211 1.26514 19.1844 4.09613 19.1844 7.58685C19.1844 11.079 16.3211 13.91 12.7891 13.91ZM3.06643 18.7732C2.86033 18.9843 2.57563 19.1177 2.25683 19.1177C1.63405 19.1177 1.12842 18.6178 1.12842 18.0006C1.12842 17.6868 1.26335 17.4053 1.47539 17.2016L1.46946 17.1957L6.62811 12.0967C7.07888 12.6978 7.61566 13.2285 8.2236 13.6756L3.06643 18.7732ZM12.7891 0C8.55129 0 5.11565 3.39836 5.11565 7.58694C5.11565 8.86829 5.44038 10.0734 6.00681 11.1334L0.671707 16.4068L0.676156 16.4112C0.259489 16.8159 0 17.3788 0 18.0005C0 19.2334 1.00978 20.2333 2.25682 20.2333C2.88701 20.2333 3.45492 19.9753 3.86417 19.5633L9.19779 14.2898C10.2684 14.8528 11.4902 15.1753 12.7891 15.1753C17.027 15.1753 20.4626 11.777 20.4626 7.58694C20.4626 3.39836 17.027 0 12.7891 0Z",
    transform: "translate(20.7144 0.578125) scale(-1 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47656 0C2.00474 0 0 1.98067 0 4.42608C0 4.60054 0.143831 4.74129 0.320284 4.74129C0.496737 4.74129 0.639086 4.60054 0.639086 4.42608C0.639086 2.33106 2.35765 0.631878 4.47656 0.631878C4.65302 0.631878 4.79685 0.491135 4.79685 0.316672C4.79685 0.140743 4.65302 0 4.47656 0Z",
    transform: "translate(12.4019 3.73999) scale(-1 1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e54c85e3d308ffa4787c704c85d2409f.svg";
export { ForwardRef as ReactComponent };